import PhoneFrame from "../PhoneFrame";
import {
    APP_SCREEN_HOME,
    APP_SCREEN_PROFILE,
    COZY_AUTUMN_IMG,
} from "./assets";

const SectionIntro = () => (
    <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C4956A]">
            A peek inside
        </span>
        <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-3">
            Real screens, <span className="italic">real warmth</span>.
        </h2>
        <p className="mt-5 text-[#6B655C] text-lg">
            Discover books, build your reading bag, journal your
            thoughts, and keep all your reading tools in one cozy place.
        </p>
    </div>
);

const PreviewPhone = ({ src, alt, testId, glowCls, rotateCls, wrapCls, title, sub }) => (
    <div className={`relative ${wrapCls || ""}`}>
        <div className={`absolute inset-0 -m-6 ${glowCls} rounded-[3rem] blur-3xl`} />
        <PhoneFrame
            src={src}
            alt={alt}
            testId={testId}
            className={`relative ${rotateCls} hover:rotate-0 transition-transform duration-700`}
        />
        <div className="relative mt-5 text-center">
            <p className="font-serif text-xl text-[#2D2D2D]">{title}</p>
            <p className="text-sm text-[#6B655C] mt-1">{sub}</p>
        </div>
    </div>
);

export const AppPreview = () => (
    <section
        data-testid="app-preview-section"
        className="relative py-24 md:py-32 overflow-hidden"
    >
        <img
            src={COZY_AUTUMN_IMG}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover opacity-[0.18]"
        />
        <div className="absolute inset-0 bg-[#FDF6EE]/80 backdrop-blur-[1px]" />

        <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
            <SectionIntro />
            <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-16">
                <PreviewPhone
                    src={APP_SCREEN_HOME}
                    alt="BookBlend home — Discover, Build Your Bag, Journal"
                    testId="app-preview-home"
                    glowCls="bg-[#C4956A]/15"
                    rotateCls="-rotate-3"
                    title="Daily Home"
                    sub="Discover, build your bag, journal."
                />
                <PreviewPhone
                    src={APP_SCREEN_PROFILE}
                    alt="BookBlend reader profile — clubs, chat, social media manager"
                    testId="app-preview-profile"
                    glowCls="bg-[#E86A58]/15"
                    rotateCls="rotate-3"
                    wrapCls="md:mt-12"
                    title="Reading Tools"
                    sub="Clubs, chat, social, your library."
                />
            </div>
        </div>
    </section>
);
